const filters = [
    "Alimentação e Delivery",
    "Assinatura e Serviços",
    "Educação",
    "Games e Eletrônicos",
    "Lazer e Entretenimento",
    "Saúde e bem-estar",
    "Vestuário e Acessórios",
    "Viagens e Turismo",
    "Diversos"
]

export default filters